import ErrorConfig from "./ErrorConfig";
export default ErrorConfig;
